import { CA, MX, US } from 'country-region-data';

const allCountries = [US, CA, MX];

export default {
    methods: {
        getRegionsForCountry(country) {
            const regions = allCountries.find((entry) => {
                if (this.countryName) {
                    return entry[0] === country;
                }

                return entry[1] === country;
            })[2];

            return regions?.map(([name, shortCode]) => ({ shortCode, name }));
        },
        // https://gist.github.com/fitnr/5818825
        splitAddress(input) {
            const address = input.trim().split(' '),
                // Check if number is numeric
                // https://stackoverflow.com/a/1830844/207509
                isNumeric = (number) =>
                    (Object.prototype.toString.call(number) === '[object Number]' || Object.prototype.toString.call(number) === '[object String]') &&
                    !Number.isNaN(Number.parseFloat(number)) &&
                    Number.isFinite(Number.parseFloat(number)),
                // Check if character is a fraction, e.g. ¼
                isFractionalChar = (character) => {
                    const code = character.codePointAt();

                    return (code >= 188 && code <= 190) || (code >= 8531 && code <= 8542);
                },
                // return the first fractional character in a string, return -1 if there is none
                indexFractionalChar = (string) => {
                    const characters = [...string];

                    return characters.indexOf(isFractionalChar);
                };

            let number;

            if (address.length <= 1) {
                return { number: '', space: '', street: address.join('') };
            }

            if (!(isNumeric(address[0].slice(0, 1)) || isFractionalChar(address[0].slice(0, 1)))) {
                // If there isn't a leading number, just return the trimmed input as the street
                return { number: '', space: '', street: input.trim() };
            }

            number = address.shift();

            if (/\d\/\d/.test(address[0]) || indexFractionalChar(address[0]) !== -1) {
                number += ` ${address.shift()}`;
            }

            return { number, space: ' ', street: address.join(' ') };
        },
    },
};
